import { create } from 'zustand';

export interface Toast {
  id: number;
  text: string;
  tone: 'success' | 'error' | 'info';
}

interface ToastState {
  toasts: Toast[];
  push: (text: string, tone?: Toast['tone']) => void;
}

let nextId = 1;

export const useToastStore = create<ToastState>((set) => ({
  toasts: [],
  push: (text, tone = 'info') => {
    const id = nextId++;
    set((s) => ({
      toasts: [...s.toasts.filter((t) => t.text !== text), { id, text, tone }].slice(-3),
    }));
    setTimeout(() => set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) })), 3200);
  },
}));

export const toast = (text: string, tone?: Toast['tone']) =>
  useToastStore.getState().push(text, tone);
